import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LockIcon, ArrowRightIcon } from 'lucide-react';
interface LockScreenProps {
  onUnlock: () => void;
}
const CORRECT_PASSWORD = 'Dev-emmy';
export const LockScreen: React.FC<LockScreenProps> = ({
  onUnlock
}) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [time, setTime] = useState(new Date());
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    inputRef.current?.focus();
    return () => clearInterval(timer);
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      onUnlock();
    } else {
      setError(true);
      setPassword('');
      setTimeout(() => setError(false), 600);
    }
  };
  const formatTime = (date: Date) => date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: false
  });
  const formatDate = (date: Date) => date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  });
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0,
    transition: {
      duration: 0.6
    }
  }} className="fixed inset-0 z-50 flex flex-col items-center justify-between py-16 px-4" style={{
    backgroundImage: 'url(https://images.unsplash.com/photo-1542831371-29b0f74f9713?w=2000&q=80)',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-336" data-mp="3osjuduzwzi72">
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" data-id="element-337" data-mp="314sg4lutcv35" />

      {/* Top: Time + Date */}
      <motion.div initial={{
      y: -20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.2
    }} className="relative z-10 text-center text-white" data-id="element-338" data-mp="ldo1i89d3syw">
        <div className="text-sm font-medium tracking-wide opacity-90" data-id="element-339" data-mp="sd6pzwr5zks0">
          {formatDate(time)}
        </div>
        <div className="text-8xl font-light tracking-tight drop-shadow-lg mt-1" data-id="element-340" data-mp="xemg43878hh9">
          {formatTime(time)}
        </div>
      </motion.div>

      {/* Bottom: Avatar + Password */}
      <motion.div initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.4
    }} className="relative z-10 flex flex-col items-center gap-4" data-id="element-341" data-mp="4qqi8v6w8jiw">
        <div className="w-24 h-24 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-3xl font-bold text-white shadow-2xl border-2 border-white/20" data-id="element-342" data-mp="jf4s3q2q988y">
          ES
        </div>
        <div className="text-white font-semibold text-lg" data-id="element-343" data-mp="3n1bxih6jmnwb">Emmanuel Saka</div>

        <form onSubmit={handleSubmit} className="flex flex-col items-center gap-3" data-id="element-344" data-mp="246qxq41fneig">
          <motion.div animate={error ? {
          x: [0, -8, 8, -8, 8, 0]
        } : {
          x: 0
        }} transition={{
          duration: 0.4
        }} className={`relative flex items-center bg-white/10 backdrop-blur-xl border ${error ? 'border-red-400' : 'border-white/20'} rounded-full px-4 py-2 w-72`} data-id="element-345" data-mp="206ykhe13gk6r">
            <LockIcon size={14} className="text-white/60 mr-2" data-id="element-346" data-mp="1chxl0ga8ojdm" />
            <input ref={inputRef} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter Password" className="flex-1 bg-transparent outline-none border-none text-white placeholder-white/40 text-sm" autoComplete="off" data-id="element-347" data-mp="17hrlkdxq9skz" />
            <button type="submit" className="ml-2 w-7 h-7 rounded-full bg-white/20 hover:bg-white/30 transition-all hover:-translate-y-0.5 flex items-center justify-center text-white" aria-label="Unlock" data-id="element-348" data-mp="2xnxxp7wugims">
              <ArrowRightIcon size={14} data-id="element-349" data-mp="2su36zkitn3e7" />
            </button>
          </motion.div>
          <AnimatePresence data-id="element-350" data-mp="2eutyz84rrflb">
            {error && <motion.div initial={{
            opacity: 0,
            y: -5
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} className="text-red-300 text-xs font-medium" data-id="element-351" data-mp="2exgafius6f8t">
                Incorrect password. Try again.
              </motion.div>}
          </AnimatePresence>
          <div className="text-white/50 text-xs" data-id="element-352" data-mp="844aq8b52irf">Hint: Dev-emmy</div>
        </form>
      </motion.div>

      {/* Bottom hint */}
      <div className="relative z-10 text-white/60 text-xs tracking-wider uppercase" data-id="element-353" data-mp="1nnv9w61lp73e">
        Touch ID or Enter Password
      </div>
    </motion.div>;
};